var _defs, _image, _g, _text, _rect, _g2, _text2, _rect2, _text3, _rect3, _text4, _g3, _g4, _text5, _rect4, _text6, _rect5, _text7, _g5, _path, _text8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssinarContratosNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ctas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e3e0e0;\n      }\n\n      .cls-2, .cls-3, .cls-7, .cls-8 {\n        font-size: 15px;\n      }\n\n      .cls-15, .cls-2, .cls-7, .cls-8 {\n        fill: #999;\n      }\n\n      .cls-14, .cls-2, .cls-6 {\n        text-anchor: middle;\n      }\n\n      .cls-14, .cls-2, .cls-3, .cls-6, .cls-7, .cls-8 {\n        font-family: Ubuntu;\n      }\n\n      .cls-2, .cls-3, .cls-6, .cls-9 {\n        font-weight: 700;\n      }\n\n      .cls-2 {\n        text-transform: uppercase;\n      }\n\n      .cls-12, .cls-14, .cls-3, .cls-5 {\n        fill: #ddd;\n      }\n\n      .cls-4, .cls-6 {\n        fill: #fdfdfd;\n      }\n\n      .cls-4 {\n        filter: url(#filter);\n      }\n\n      .cls-5 {\n        stroke: #ff4d4d;\n        stroke-linejoin: round;\n        stroke-width: 1px;\n      }\n\n      .cls-12, .cls-13, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        font-size: 13px;\n      }\n\n      .cls-7 {\n        text-anchor: end;\n      }\n\n      .cls-7, .cls-8 {\n        font-weight: 300;\n      }\n\n      .cls-10 {\n        fill: #262b2d;\n      }\n\n      .cls-11 {\n        fill: #ddd;\n      }\n\n      .cls-13 {\n        fill: #dbdce0;\n      }\n\n      .cls-14 {\n        font-size: 13.629px;\n        font-weight: 500;\n      }\n\n      .cls-16 {\n        fill: #c1bfbf;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: -15,
    y: 66,
    width: 1651,
    height: 83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.95,
    dy: 4.95,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "logo",
    x: -134,
    y: -266,
    width: 183,
    height: 58,
    xlinkHref: "data:img/png;base64,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"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voltar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_1",
    "data-name": "Rounded Rectangle 1",
    className: "cls-1",
    x: 617.5,
    y: 620.094,
    width: 366,
    height: 72,
    rx: 36,
    ry: 36
  }), /*#__PURE__*/React.createElement("text", {
    id: "Agendar_sess\\xE3o",
    "data-name": "Agendar sess\\xE3o",
    className: "cls-2",
    transform: "translate(-381.72 -1507.689) scale(1.548 1.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Voltar")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Clique_no_contrato_que_deseja_e_prossiga_para_a_assinatura.",
    "data-name": "Clique no contrato que deseja e prossiga para a assinatura.",
    className: "cls-3",
    transform: "translate(0 198.836) scale(1.294)"
  }, "Clique no contrato que deseja e prossiga para a assinatura.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_2_copy",
    "data-name": "Rounded Rectangle 2 copy",
    className: "cls-4",
    x: -11,
    y: 70,
    width: 1632,
    height: 64,
    rx: 32,
    ry: 32
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "valor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-5",
    d: "M1497,103c0-13.255,12.17-24,27.18-24h52.64c15.01,0,27.18,10.745,27.18,24h0c0,13.255-12.17,24-27.18,24h-52.64c-15.01,0-27.18-10.745-27.18-24h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    className: "cls-6",
    transform: "translate(1327.141 -249.243) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "R$ XX,XX")), /*#__PURE__*/React.createElement("text", {
    id: "Parcela_s_Vencida_s",
    "data-name": "Parcela(s) Vencida(s",
    className: "cls-7",
    transform: "translate(1119.824 -250.237) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Valor total:")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Regi\\xF5es_contratadas:_copy",
    "data-name": "Regi\\xF5es contratadas: copy",
    className: "cls-8",
    transform: "translate(246.782 -250.251) scale(1.075 1.075)"
  }, "Regi\xF5es contratadas:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "Virilha Completa")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Path_copy_2",
    "data-name": "Path copy 2",
    className: "cls-11",
    x: 389,
    y: 97,
    width: 1,
    height: 14
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Regi\\xF5es_contratadas:",
    "data-name": "Regi\\xF5es contratadas:",
    className: "cls-8",
    transform: "translate(69.782 -250.251) scale(1.075 1.075)"
  }, "Data:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "07/09/2020")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    className: "cls-11",
    x: 212,
    y: 97,
    width: 1,
    height: 14
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "Contrato:_100201",
    "data-name": "Contrato: 100201",
    className: "cls-8",
    transform: "translate(-103.218 -250.237) scale(1.075 1.075)"
  }, "Contrato:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "100302")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    className: "cls-12",
    d: "M0,103a23,23,0,1,1,23,23A23,23,0,0,1,0,103Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "valor-2",
    "data-name": "valor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape-2",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-5",
    d: "M1497,24c0-13.255,12.17-24,27.18-24h52.64C1591.83,0,1604,10.745,1604,24h0c0,13.255-12.17,24-27.18,24h-52.64C1509.17,48,1497,37.255,1497,24h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    className: "cls-6",
    transform: "translate(1327.141 -328.243) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "R$ XX,XX")), /*#__PURE__*/React.createElement("text", {
    id: "Parcela_s_Vencida_s-2",
    "data-name": "Parcela(s) Vencida(s",
    className: "cls-7",
    transform: "translate(1119.824 -329.237) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Valor total:")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "Regi\\xF5es_contratadas:_copy-2",
    "data-name": "Regi\\xF5es contratadas: copy",
    className: "cls-8",
    transform: "translate(246.782 -329.251) scale(1.075 1.075)"
  }, "Regi\xF5es contratadas:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "Axilas, Pernas")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Path_copy_2-2",
    "data-name": "Path copy 2",
    className: "cls-11",
    x: 389,
    y: 18,
    width: 1,
    height: 14
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "Regi\\xF5es_contratadas:-2",
    "data-name": "Regi\\xF5es contratadas:",
    className: "cls-8",
    transform: "translate(69.782 -329.251) scale(1.075 1.075)"
  }, "Data:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "04/09/2020")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-11",
    x: 212,
    y: 18,
    width: 1,
    height: 14
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "Contrato:_100201-2",
    "data-name": "Contrato: 100201",
    className: "cls-8",
    transform: "translate(-103.218 -329.237) scale(1.075 1.075)"
  }, "Contrato:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "100201")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon-2",
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-2",
    "data-name": "Ellipse",
    className: "cls-12",
    d: "M0,24A23,23,0,1,1,23,47,23,23,0,0,1,0,24Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Group:_6_objects",
    "data-name": "Group: 6 objects",
    x: 11,
    y: 14,
    width: 23,
    height: 21,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAABMklEQVQ4jeVV7Y2DMAw1Tx2gIzBCR+gKtwEjXDfoTVBGYIRuUG4DNrgbgQXsnB4YCVESKFV1PxrJivz17Dh2kqlqkBetnYicRGQvIoWHqJ4INcZosxD6xM2s5g7guBV5irFbMOaJDgmTBkAbUybB/ZiXhJ4lLTeBAyhTzksLWx3fENzMDmYWzOzT+cL5OfqNgcculA5XEamd536O2D7Wit67HyOewb5iIA+BS18KlqRioIVhagE0q8FZcx+evZdjaZiyOeHshXomx2GAOEwAshjFIkbLAuA7kemq9T8Tama5mSWfX+pptxrcHdjjPyJy45Cwc7xjumfYebbnjXa0n02EnwVJVWt+eSMiX6pq6zx3ysY89Xd+A+YUnA6VquaD3HWFqjbuzL2Y6HP36xLo5CHIHzZrMcdyfIsYAAAAAElFTkSuQmCC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linha",
    className: "cls-13",
    d: "M1705-39H-103v-1H1705v1Z"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "_1._Assinar_contrato_2._Detalhes_do_contrato_",
    "data-name": "1. Assinar contrato    \\u2022     2. Detalhes do contrato     \\u2022     ",
    className: "cls-14",
    transform: "translate(803.914 -173.28) scale(2.476)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "1. Assinar contrato", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16"
  }, "\u2022     2. Detalhes do contrato     \u2022     3.Assinatura     \u2022     4. Finalizado!"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssinarContratosNormal);
export default __webpack_public_path__ + "static/media/assinar-contratos-normal.2a290e1e9ffa08ee7d57b1df649de430.svg";
export { ForwardRef as ReactComponent };